import { Component, OnInit, Input, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { menuConfig } from './menu-constant'
import { Router } from '@angular/router';
import { BaseComponent } from '.././shared/base.component';
import { SharedService } from '.././shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from './menu.service';
import { GlobalInfo, FPMessage, Severities, RoleGroups } from '.././shared/shared.model';
import { MenuItem, SubMenuItem } from './menu.model';

import { Http, Headers, Response, RequestOptions, URLSearchParams } from '@angular/http';
@Component({
    // moduleId: module.id,
    selector: 'side-menu',
    templateUrl: 'menu.component.html',
    styleUrls: ['menu.component.css']
})

export class MenuComponent implements OnInit {
    globalInfo: GlobalInfo;
    // menus: MenuItem[] = [];
    //selectedMenu: MenuItem;
    SiteaAdmin: boolean = false;
    @Input() selectedMenu: MenuItem;
    @Input() menus: MenuItem[];
    @Output() done = new EventEmitter();

    //to mange the menu css class 
    sideBarSlide: string = '';
    sideBarSlide2: string = '';
    leftToggleMenu: string = '';
    rightToggleMenu: string = '';
    slideScroll: string = '';
    defaultLeft: string = '';

    menuSecondLevelToggle: boolean = false;
    selectedMenuId: number;

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.eRef.nativeElement.contains(event.target)) {
            console.log('inside');
        } else {
            this.setSideMenuFirst(false);
            this.setSideMenu(false);
        }
    }

    constructor(private eRef: ElementRef, private menuService: MenuService, private route: Router, private sharedService: SharedService, private translate: TranslateService) {
        this.globalInfo = this.sharedService.globalInfo();
    }

    ngOnInit() {
        var id = this.menus;
        this.selectedMenu = this.menus[0];
        this.setSideMenu(false);
        this.setSideMenuFirst(this.route.url == "/home");
    }

    menuClick(menu: MenuItem) {
        debugger;
        this.setSideMenu(menu.MenuName != 'Home');
        this.setMenuSelected(menu);
        if (menu.UiPageName == '' && menu.MenuName == 'Home') {
            this.route.navigate(['/home']);
        }
    }
 ValidURL(str) {
        var re = new RegExp("^(http|https)://");
        if (!re.test(str))
            return false;
        else
            return true;
    }

    subMenuclick(menu: MenuItem, submenu: SubMenuItem) {
debugger;
        if (this.selectedMenuId == submenu.MenuId) {
            this.selectedMenuId = 0;
        }
        else {
            this.selectedMenuId = submenu.MenuId;
        }

        //second-level menu click
        // $('.second-level > .main-menu  ul.sublist > li > a').click(function () {
        //     $('.second-level > .main-menu ul.sublist > li').removeClass('active');
        //     $(this).parent('li').addClass('active');
        // });

        //this.setMenuSelected(menu);

        // if (submenu.UiPageName == "" || submenu.UiPageName == null) {
        //     this.menuSecondLevelToggle = true;
        // }
        //submenu.ActClass=

        this.menuSecondLevelToggle = !this.menuSecondLevelToggle;
        //alert(submenu.UiPageName);
        this.setSideMenu(true);
        if (submenu.UiPageName == null || submenu.UiPageName == "") { return; }
        this.setSideMenu(false);
        
        // if (submenu.IsExternal == true) {
        //     window.open(Elixir_Url.BaseURL + '/' + submenu.UiPageName + "?uri=" + submenu.UiPageName, "_self")
        //     //this.route.navigate(['/' + submenu.UiPageName + "/" + 0]);
        //     return;
        // }
          if (this.ValidURL(submenu.UiPageName)) {
            // url = url.split('//')[1];
            // url = url.replace(url.split('/')[0], "");
            window.open(submenu.UiPageName + "?uri=" + submenu.UiPageName, "_self")
            //this.route.navigate(['/' + submenu.UiPageName + "/" + 0]);
            return;
        }

        if (submenu.UiPageName === 'managecustomers') {
            this.route.navigate(['/customview/customer']);
        }
        else if (submenu.UiPageName === '/customview/customer?create=true') {
            this.route.navigate(['/customview/customer'], { queryParams: { create: true, random: Math.random() } });
        }
        else if (submenu.UiPageName === '/customview/ManageProjects?create=true') {
            this.route.navigate(['/customview/ManageProjects'], { queryParams: { create: true, random: Math.random() } });
        }
        else if (submenu.UiPageName === 'createpm') {
            this.route.navigate(['/pm/pm'], { queryParams: { create: true, random: Math.random() } });
        }
        else if (submenu.UiPageName === '/pm/pmequipmentcreate') {
            this.route.navigate(['/pm/pmequipment'], { queryParams: { create: true, random: Math.random() } });
        }
        else if (submenu.UiPageName === '/project/createproject') {
            this.route.navigate(['/project'], { queryParams: { create: true, random: Math.random() } });
        }
        else if (submenu.UiPageName === "/workorder/createworkorder") {
            this.route.navigate(['/' + submenu.UiPageName + "/" + 0]);
        }
        else {
            this.route.navigate([submenu.UiPageName]);
        }
    }

    subMenu2click(menuName, url) {
        debugger;
        if (menuName == null || menuName == "" && url == null || url == "") return;

        this.setSideMenu(false);

        if (url === '/admin/company') {

            this.SiteaAdmin = (this.globalInfo.MaxRoleGroup == RoleGroups.SiteAdmin);
            if (this.globalInfo.CompanyId == 1) {
                this.route.navigate(['/company/company']);
            }
            else {
                this.route.navigate(['/company/companydetails/' + this.globalInfo.CompanyId]);
            }
        }
        else {
            if (url.substring(0, 19).trim().toLowerCase() == "/reports/dashboards") {
                var a = url.split('id=')[1];
                var b = new URLSearchParams('id=' + a);
                var id = b.get('id');               
                var pageUrl = url.split('?id=')[0];
                this.route.navigate([pageUrl + "/" + id]);
            }
            else {
                this.route.navigate([url]);
            }
        }
    }

    toggleSideMenuFirst() {
        this.setSideMenuFirst(this.leftToggleMenu == 'rotate-font');
    }
    toggleSideMenu() {
        this.setSideMenu(this.rightToggleMenu == 'rotate-font');
    }

    private setSideMenuFirst(open: boolean) {
        if (open) {
            this.defaultLeft = "167px";
            this.sideBarSlide = '';
            this.leftToggleMenu = '';
            this.slideScroll = '';
        } else {
            this.defaultLeft = "50px";
            this.sideBarSlide = 'sidebar-mini';
            this.leftToggleMenu = 'rotate-font';
            this.slideScroll = 'ovrdesk-hide';
        }
    }

    private setSideMenu(open: boolean) {
        if (open) {
            this.sideBarSlide2 = '';
            this.rightToggleMenu = '';
            this.slideScroll = '';
        } else {
            this.sideBarSlide2 = 'sidebar-mini';
            this.rightToggleMenu = 'rotate-font';
            this.slideScroll = 'ovrdesk-hide';
        }
    }

    private setMenuSelected(menu: MenuItem) {
        this.selectedMenu.ActClass = '';
        menu.ActClass = 'active';
        this.selectedMenu = menu;
    }


}



